module.exports = __webpack_public_path__ + "img/arrow_goal.5369d968.svg";